import React from 'react'

const Container = props => {
  return (
    <div className="flex w-full min-h-screen bg-secondary lg:bg-white">
      <div className="relative w-full shadow-3xl lg:max-w-lg lg:bg-primary">
        <div className="flex relative z-10 flex-col p-6 md:p-8">
          {props.children}
        </div>
      </div>
      <div className="hidden flex-1 p-16 bg-right-top bg-no-repeat bg-cover desktop-background xl:p-32 lg:flex lg:flex-col lg:justify-end">
        <h3 className="mb-6 text-5xl font-semibold leading-tight">
          <span className="block mb-4 text-2xl font-semibold text-secondary">
            CLICK &amp; COLLECT
          </span>
          Your grocery shopping made simple
        </h3>
        <p className="text-2xl font-medium">
          Simply shop online and choose a collection location and time to suit
          you.
        </p>
      </div>
    </div>
  )
}

export default Container
